/* eslint-disable import/prefer-default-export */

export enum SignUpSteps {
  CreateAccount,
  VerifyAccount,
  VerifyingAccount,
  SetupPassword,
  AccountDetails,
  AccountCreated,
}
